import React, { ReactNode } from 'react';

export interface SidebarSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  children: ReactNode;
  collapsed?: boolean;
  className?: string;
}

export const SidebarSection = ({
  title,
  children,
  collapsed = false,
  className = '',
  ...props
}: SidebarSectionProps) => {
  return (
    <div className={`${className}`} {...props}>
      {title && (
        collapsed ? (
          <div className="h-px bg-slate-700/50 mx-4 my-3" />
        ) : (
          <div className="text-xs uppercase text-slate-600 tracking-[0.1em] font-semibold px-4 mb-2 transition-opacity duration-200">
            {title}
          </div>
        )
      )}
      <div className="space-y-1">
        {children}
      </div>
    </div>
  );
};
